import { render } from "./carousel.pug?vue&type=template&id=8e970ba6&ts=true&lang=pug&external"
import script from "./carousel.ts?vue&type=script&lang=ts&external"
export * from "./carousel.ts?vue&type=script&lang=ts&external"

import "./carousel.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__